import { urlApiTegra, get, post, put, del, putFile, postFormData } from "../../../service/api";

const url = urlApiTegra;

const getClients = (token: string) => {
  return get(`${url}/client`, token);
};

const getClientById = (token: string, id: string | number) => {
  return get(`${url}/client/${id}`, token);
};

const getProjectByClient = (token: string, id: string | number) => {
  return get(`${url}/client/by-project/${id}`, token);
};

const postClient = (token: string, { body, file = undefined }) => {
  const bodyInString = JSON.stringify(body);
  return postFormData(`${url}/client`, { body: bodyInString, file }, token);
};

const putClient = (token: string, { body, file = undefined }: { body: any; file?: any }, id: string | number) => {
  const bodyInString = JSON.stringify(body);
  return putFile(`${url}/client/${id}`, { body: bodyInString, file }, token);
};

const deleteImageClient = (token: string, id: number | string) => {
  return del(`${url}/client/image/${id}`, token);
};

const uploadCsvAndXlsxClient = async ({ file, token, path }: { file: any; token: string; path: string }) => {
  return postFormData(`${url}/upload-sheet/client-${path}`, { file }, token);
};

export { getClients, getClientById, getProjectByClient, postClient, putClient, deleteImageClient, uploadCsvAndXlsxClient };
